import 'resize-observer-polyfill';
import React from 'react';
import Measure from 'react-measure';
import { Redirect, Switch, Route } from 'react-router-dom';

import { withBaseContainer } from './BaseContainer';
import BCLLoading from '../common/Loading/BCLLoading';
import ErrorMain from '../common/Error/ErrorMain';

import { notifyHeightChange } from '../../helpers/helper';
import { WIDGET_PATHS, WIDGET_BASE_PATH } from '../../constants/paths';

const PreferencesContent = React.lazy(() => import(/* webpackChunkName: "PreferencesContent" */ '../standalone/Preferences/PreferenceContent/PreferencesContent'));

const Widget = (props) => {
  return (
    <div className="widget-container">
      <React.Suspense fallback={<BCLLoading />}>
        <Measure
          bounds
          onResize={contentRect => {
            setTimeout(() => {
              notifyHeightChange(props.queryParams['widgetId'], contentRect.bounds.height);
            }, 0);
          }}
        >
          {({ measureRef }) => (
            <div ref={measureRef}>
                <Switch>
                  <Redirect exact from={WIDGET_BASE_PATH} to={WIDGET_PATHS.PREFERENCES} />
                  <Route path={WIDGET_PATHS.PREFERENCES} render={() => <PreferencesContent routePath={WIDGET_PATHS.PREFERENCES} />} />
                  <Route component={ErrorMain} />
                </Switch>
            </div>
          )}
        </Measure>
      </React.Suspense>
    </div>
  )
}

export default withBaseContainer(Widget);
